
import { mapGetters } from 'vuex'
export default {
    name: 'ReleaseSteps',
    props: {
        currentRouteName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            stepsList: []
        }
    },
    computed: {
        currentStep() {
            // 在显示的步骤列表中找到当前路由对应的步骤索引
            const stepIndex = this.stepsList.findIndex(step => step.key.includes(this.currentRouteName))
            return stepIndex >= 0 ? stepIndex : 0
        },

    },
    methods: {
        getStepStatus(stepIndex) {
            if (stepIndex < this.currentStep) return 'completed'
            if (stepIndex === this.currentStep) return 'current'
            return 'pending'
        },
        getStepsList(releaseGoodsCatalogueId) {
            console.log('===============releaseGoodsCatalogueId', releaseGoodsCatalogueId)
            // 初始状态
            const steps = [
                {
                    name: '选择游戏',
                    key: ['selectGame'],
                    isShow: true
                },
                {
                    name: '商品类别',
                    key: ['selectCategory'],
                    isShow: true
                },
                {
                    name: '选择区服',
                    key: ['selectServer'],
                    isShow: false
                },
                {
                    name: '填写信息',
                    key: ['editAccount', 'editCategory'],
                    isShow: true
                },
                {
                    name: '官方审核',
                    key: ['success'],
                    isShow: true
                }
            ]

            // 如果选中的类别是成品号(goodsCatalogueId === 6)，显示选择区服步骤
            if (releaseGoodsCatalogueId === 6) {
                steps[2].isShow = true
            }

            return steps.filter(item => item.isShow)
        }
    },
    computed: {
        releaseGoodsCatalogueId() {
            return this.$store.state.game.releaseGoodsCatalogueId
        },
        currentStep() {
            // 在显示的步骤列表中找到当前路由对应的步骤索引
            const stepIndex = this.stepsList.findIndex(step => step.key.includes(this.currentRouteName))
            return stepIndex >= 0 ? stepIndex : 0
        }
    },
    watch: {
        releaseGoodsCatalogueId: {
            handler(newVal) {
                console.log('===============watch releaseGoodsCatalogueId', newVal)
                this.stepsList = this.getStepsList(newVal)
            },
            immediate: true
        }
    },
    unmounted() {
        // 组件卸载的时候清除发布商品的类别ID
        this.$store.commit('game/SET_RELEASE_GOODS_CATALOGUE_ID', null)
    }
}
